import HttpService from "../services/Http.Service";

async function getSensorLog(data) {
    return await HttpService.controlServerWithToken("GET", "sensor_event", "get_sensor_log", data);
}

async function getSensorEventLive(data) {
    return await HttpService.controlServerWithToken("GET", "sensor_event", "get_sensor_event_live", data);
}

async function getSensorEventLiveSimple(data) {
    return await HttpService.controlServerWithToken("GET", "sensor_event", "get_sensor_event_live_simple", data);
}

async function getSensorEventLog(data) {
    return await HttpService.controlServerWithToken("GET", "sensor_event", "get_sensor_event_log", data);
}

async function addSensorLog(data) {
    return await HttpService.controlServerWithToken("POST", "sensor_event", "add_sensor_log", data);
}

async function addSensorEventLog(data) {
    return await HttpService.controlServerWithToken("POST", "sensor_event", "add_sensor_event_log", data);
}

async function addSensorEventLive(data) {
    return await HttpService.controlServerWithToken("POST", "sensor_event", "add_sensor_event_live", data);
}

async function updateSensorEventLive(data) {
    return await HttpService.controlServerWithToken("POST", "sensor_event", "update_sensor_event_live", data);
}

async function deleteSensorEventLive(data) {
    return await HttpService.controlServerWithToken("POST", "sensor_event", "delete_sensor_event_live", data);
}

async function checkIn(data) {
    return await HttpService.controlServerWithToken("POST", "sensor_event", "check_in", data);
}

export {
    getSensorLog,
    getSensorEventLive,
    getSensorEventLiveSimple,
    getSensorEventLog,
    addSensorLog,
    addSensorEventLog,
    addSensorEventLive,
    updateSensorEventLive,
    deleteSensorEventLive,
    checkIn,
};
